import React from "react";
import logo from 'assets/img/ic-logo.png';
import './Header.scss'

export const Header: React.FC = () => {
  return (
    <div className="app-header navbar sticky-top">
      <div className="container">
      <div className="app-brand">
        <img src={logo} alt="" />
        <span>Super Translate</span>
      </div>
      </div>
      
    </div>
  )
}